module.exports = __webpack_public_path__ + "img/featured02.d80e7cee.jpeg";